import { UserMediaProvider } from "@/Components/Providers";
import { FC, PropsWithChildren } from "react";

const GetOrderUploadVideoAndSignatureLayout: FC<PropsWithChildren> = ({ children }) => (
  <UserMediaProvider
    constraints={{
      audio: true,
      video: {
        aspectRatio: { max: 1.0, ideal: 1.0 },
        width: { max: 240, min: 240 },
        height: { min: 240, max: 240 },
        frameRate: { ideal: 15, min: 10 },
      },
    }}
  >
    {children}
  </UserMediaProvider>
);

export default GetOrderUploadVideoAndSignatureLayout;
